import React from "react";
import { UserType } from "../../../../../../models/userType";
import { Row, SelectField, byClientType, bySalesman } from "./fields";

/**
 * The client type (the program grant) plus the rep, which only Sales_Rep needs.
 * Kept in the row it has always occupied, below the analytics profile.
 */
const ProgramTypeSection = ({
  form,
  clientTypes,
  salesReps,
  showSalesRep,
  onClientTypeChange,
}: {
  form: any;
  clientTypes: any[];
  salesReps: any[];
  showSalesRep: boolean;
  onClientTypeChange: (clientType: any) => void;
}) => (
  <Row>
    <SelectField
      id="client_type"
      label="Client Type"
      form={form}
      options={clientTypes}
      onPick={onClientTypeChange}
      {...byClientType}
    />
    {showSalesRep &&
      form.values.client_type?.client_type_index === UserType.Index.SalesRep && (
        <SelectField
          id="sale_rep"
          label="Sale Rep"
          xs={8}
          form={form}
          options={salesReps}
          {...bySalesman}
        />
      )}
  </Row>
);

export default ProgramTypeSection;
